import { MARKET_MOVERS_ACTIONS, MARKET_MOVERS_ACTION_TYPES } from "../actions/marketMovers"
import { apiStatusInitialState, apiStatusStateType } from "../misc"
import { ClusterContentApi } from "@cluster/web-components"

export type MarketMoverType = {
  id: string,
  title: string,
  direction: ClusterContentApi.FieldDirection,
  topic?: string,
  topic_img_src?: string,
  cellId: number | null,
  date: string,
  author: string
}

export type MarketMoversStateType = {
  data: {
    items: MarketMoverType[],
    latest_day: Date | null,
  }
  fetchStatus: apiStatusStateType
}

export const initialState: MarketMoversStateType = {
  data: {
    items: [],
    latest_day: null
  },
  fetchStatus: apiStatusInitialState
}

export default (state = initialState, action: MARKET_MOVERS_ACTION_TYPES): MarketMoversStateType => {

  switch (action.type) {
    case MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_START:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          loading: true,
        }
      }
    case MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          data: action.payload,
          fetchStatus: {
            ...state.fetchStatus,
            lastFetch: Date.now(),
            errorCode: null,
            developerMessage: null,
            userMessage: null,
            moreInfo: null,
            lastError: null,
            loading: false
          }
        }
      }
      // caution: break is omitted intentionally if the payload is falsey

    case MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_ERROR:
      return {
        ...state,
        fetchStatus: {
          ...state.fetchStatus,
          ...action.error,
          lastError: Date.now(),
          loading: false
        }
      }
    default:
      return state
  }
}